/* ==========================================================================
   biosled.js — 自研交互脚本（Shopify 版）
   --------------------------------------------------------------------------
   来源：website/assets/js/main.js
   改动：
     1. 删除 Formspree 提交段 —— 改由 Shopify 原生 contact form 接管；
        成功/失败提示交给 Liquid 的 form.posted_successfully? / form.errors。
     2. 表单校验逻辑保留：校验不通过阻止提交，通过后放行原生提交。
     3. 其余全部保留：header 滚动态、移动汉堡菜单、导航高亮、滚动渐显、
        8×8 像素面板、产品分类筛选、数量分档（≥20 切批发话术）、
        ?topic= 深链、页脚年份、回到顶部。
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- Header: scrolled state ---------- */
  var header = document.querySelector('.header');
  var toTop = document.querySelector('.to-top');

  function onScroll() {
    var y = window.scrollY || document.documentElement.scrollTop;
    if (header) header.classList.toggle('is-scrolled', y > 8);
    if (toTop) toTop.classList.toggle('is-show', y > 600);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- Mobile nav ---------- */
  var burger = document.querySelector('.burger');
  var nav = document.querySelector('.nav');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      burger.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    nav.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') {
        nav.classList.remove('is-open');
        burger.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---------- Active nav link by current page ---------- */
  var page = (location.pathname.split('/').pop() || '').toLowerCase();
  document.querySelectorAll('.nav a').forEach(function (a) {
    var href = (a.getAttribute('href') || '').toLowerCase();
    if (href && page && href.replace(/\/$/, '') === page.replace(/\/$/, '')) {
      a.classList.add('is-active');
      a.setAttribute('aria-current', 'page');
    }
  });

  /* ---------- Scroll reveal ---------- */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- LOY Super-App phone mockup: pixel panel ---------- */
  var panel = document.querySelector('#pixelPanel');
  if (panel) {
    // 8x8 grid, index 0 = top-left
    var lit = {
      10: 'on', 11: 'on', 12: 'on', 13: 'on',
      18: 'on b', 21: 'on b', 26: 'on b', 29: 'on b',
      34: 'on c', 35: 'on c', 36: 'on c', 37: 'on c',
      42: 'on', 45: 'on',
      51: 'on b', 52: 'on b', 53: 'on b'
    };
    var blink = [34, 35, 36, 37, 42, 45];
    var html = '';
    for (var i = 0; i < 64; i++) {
      var cls = lit[i] || '';
      if (blink.indexOf(i) > -1 && cls) cls += ' blink';
      html += '<i class="' + cls + '"></i>';
    }
    panel.innerHTML = html;
  }

  /* ---------- Product category filter ---------- */
  var filterBar = document.querySelector('.filters');
  if (filterBar) {
    filterBar.addEventListener('click', function (e) {
      var btn = e.target.closest('button');
      if (!btn) return;
      filterBar.querySelectorAll('button').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var cat = btn.getAttribute('data-filter');
      document.querySelectorAll('.product').forEach(function (card) {
        var match = cat === 'all' || card.getAttribute('data-cat') === cat;
        card.classList.toggle('is-hidden', !match);
      });
    });
  }

  /* ---------- Contact form: validation + wholesale split ---------- */
  var form = document.querySelector('#contact-form');
  if (form) {
    /* Quantity split: >= 100 pcs (MOQ) is a wholesale lead, so surface the
       wholesale message and move the enquiry type across for them.
       2026-09-17 用户拍板：档位与提示以 100 为分界（原 20）。 */
    var qty = form.querySelector('#qty');
    var qtyHint = form.querySelector('#qty-hint');
    var topic = form.querySelector('#topic');
    var WHOLESALE_MIN = 100;

    function applyQtySplit() {
      if (!qty || !qtyHint) return;
      /* 取区间起始数字判断档位：'1-19'→1（零售）、'20-99'→20（小批量）、'100-499'→100（MOQ 批发）、'1000+'→1000。
         不能用 replace(/[^0-9]/g,'') 拼接所有数字——'1-19' 会变成 119 误判为批发。 */
      var m = String(qty.value || '').match(/\d+/);
      var n = m ? parseInt(m[0], 10) : NaN;
      var wholesale = !isNaN(n) && n >= WHOLESALE_MIN;
      qtyHint.classList.toggle('is-on', wholesale);
      if (wholesale && topic && topic.value === 'Sample Request') {
        topic.value = 'Wholesale & Distribution';
      }
    }
    if (qty) {
      qty.addEventListener('change', applyQtySplit);
      applyQtySplit();
    }

    /* Deep link from the product cards: ?topic=Wholesale */
    var wanted = new URLSearchParams(location.search).get('topic');
    if (wanted && topic) {
      var opt = Array.prototype.find.call(topic.options, function (o) {
        return o.textContent.replace(/\s+/g, ' ').toLowerCase().indexOf(wanted.toLowerCase()) > -1;
      });
      if (opt) {
        topic.value = opt.value;
        if (wanted.toLowerCase() === 'wholesale' && qty) {
          qty.value = '100-499';
          applyQtySplit();
        }
      }
    }

    function setError(field, on) { field.classList.toggle('has-error', on); }

    function validate() {
      var ok = true;
      form.querySelectorAll('[data-required]').forEach(function (input) {
        var field = input.closest('.field');
        var value = (input.value || '').trim();
        var bad = !value;
        if (!bad && input.type === 'email') bad = !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
        if (field) setError(field, bad);
        if (bad) ok = false;
      });
      return ok;
    }

    /* 校验失败 → 阻止提交并聚焦第一个错误项；
       校验通过 → 不做任何拦截，交给 Shopify 原生 contact form 提交。 */
    form.addEventListener('submit', function (e) {
      if (!validate()) {
        e.preventDefault();
        var first = form.querySelector('.field.has-error input, .field.has-error textarea, .field.has-error select');
        if (first) first.focus();
        return;
      }
      var btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
    });

    form.addEventListener('input', function (e) {
      var field = e.target.closest('.field');
      if (field && field.classList.contains('has-error')) setError(field, false);
    });
  }

  /* ---------- Footer year ---------- */
  var year = document.querySelector('#year');
  if (year) year.textContent = new Date().getFullYear();

  /* ---------- BSL container hard-guard (final fallback) ----------
     Horizon theme can override !important via inline JS or @layer.
     JS setProperty(prop, val, 'important') beats every CSS rule.
     multicolumn 居中走 ".multicolumn-outer (grid 容器) + justify-items:center"
     + multicolumn-grid 固定 1032 px 宽。Grid 算法对 grid items 不会自动收缩
     （与 flex 的 flex-shrink 不同），子元素 width 永远保持——是 Shopify Horizon
     wrapper 场景下的最稳居中方案。
     此函数只作为兜底保险，正常情况 CSS 已生效。 */
  function bslGuard() {
    document.querySelectorAll('.bsl .multicolumn-outer').forEach(function (el) {
      el.style.setProperty('display', 'grid', 'important');
      el.style.setProperty('grid-template-columns', '1fr', 'important');
      el.style.setProperty('justify-items', 'center', 'important');
      el.style.setProperty('align-items', 'stretch', 'important');
      el.style.setProperty('width', '100%', 'important');
      el.style.setProperty('box-sizing', 'border-box', 'important');
    });
    /* 9-17 排障修复：旧版强写 repeat(4,240px)+1032px 把新 CSS（4 列 92% 宽）压回去，
       是四卡「改了没变化」的根因。改为与 style.css/biosled.css 断点镜像：
       桌面 4 列 min(1400px,92%) / ≤1100px 2×2 / ≤640px 单列 420px。 */
    var vw = window.innerWidth;
    var cols = vw <= 640 ? 'minmax(0,1fr)' : (vw <= 1100 ? 'repeat(2, minmax(0,1fr))' : 'repeat(4, minmax(0,1fr))');
    var gw = vw <= 640 ? 'min(420px, 92%)' : 'min(1400px, 92%)';
    document.querySelectorAll('.bsl .multicolumn-grid').forEach(function (el) {
      el.style.setProperty('display', 'grid', 'important');
      el.style.setProperty('grid-template-columns', cols, 'important');
      /* 9-17 🎯 破案：Horizon .grid 类自带 14 列 areas（column-0…13），与列数定义冲突
         按规范作废整组列定义 → 必须同步清掉 areas，四卡才能真铺开 */
      el.style.setProperty('grid-template-areas', 'none', 'important');
      el.style.setProperty('gap', '28px', 'important');
      el.style.setProperty('width', gw, 'important');
      el.style.setProperty('max-width', 'none', 'important');
      /* 9-17 晚更正：撤销 v3 的 left:50%/translateX——外层 justify-items:center 已居中，
         两套叠加会右偏 57.5px。居中只留外层一处。 */
      el.style.setProperty('box-sizing', 'border-box', 'important');
    });
  }
  bslGuard();
  window.addEventListener('resize', bslGuard);
  // Re-apply after late-loading sections hydrate
  setTimeout(bslGuard, 200);
  setTimeout(bslGuard, 1000);
  setTimeout(bslGuard, 2500);

  /* ---------- Back to top ---------- */
  if (toTop) {
    toTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
})();
